import axios from "axios";
import { message } from "@/common/js/resetMessage";
import router from "@/router";
import { Loading } from "element-ui";
import { getToken } from "@/utils/auth";
import store from "../store";
import { downloadResponse } from "@/common/js/util";

const bpkList = ['/adam/assessmentInStore'];
// 响应时间超长的api
const longApi = ['/v1/management/file-transfer/'];
const defaults = {
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000,
  // withCredentials: true,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    // 'Pragma': 'no-cache',
    "Content-type": "application/json",
    // contentType: "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
Object.assign(axios.defaults, defaults);
axios.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers["token"] = getToken();
  }
  if (longApi.some(item => config.url.includes(item))) {
    config.timeout = 300000; // 超长api5分钟
  } else {
    config.timeout = 30000;
  }

  return config;
});
// 拦截响应response，并做一些错误处理
axios.interceptors.response.use(
  response => {
    // console.info("response", response);
    const config = response.config;
    /* bpk接口单独拦截 */
    const flag = bpkList.some(item => config.url.includes(item));
    if (flag) {
      const data = response.data;
      if (data.code === 0) {
        return data;
      } else {
        return Promise.reject(data);
      }
    }
    if (response.config.responseType === "blob") {
      if (response.headers["content-disposition"]) {
        return downloadResponse(response, response.config.notDownload);
      }
    } else {
      const data = response.data;
      // 根据返回的code值来做不同的处理（和后端约定）
      if (data.errorCode === "0") {
        return data.data;
      } else {
        switch (data.errorCode) {
          case "1009020403":
            message({ message: "没有权限", type: "error" });
            break;
          default:
            !config.hideMessage && data.errorMessage &&
              message({ message: data.errorMessage, type: "error" });
        }
        return Promise.reject(data);
      }
    }
  },
  err => {
    console.info("err", err);
    // 这里是返回状态码不为200时候的错误处理
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "请求错误";
          break;
        case 401:
          err.message = "未授权，请登录";
          store.dispatch("user/resetToken").then(() => {
            const token = getToken();
            if (!token) {
              router.push({ path: "/login" }).catch(error => {
                console.log(error);
              });
            }
          });
          break;
        case 403:
          err.message = "拒绝访问";
          break;
        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`;
          break;
        case 408:
          err.message = "请求超时";
          break;
        case 500:
          err.message = "服务器内部错误";
          break;
        case 501:
          err.message = "服务未实现";
          break;
        case 502:
          err.message = "网关错误";
          break;
        case 503:
          err.message = "服务不可用";
          break;
        case 504:
          err.message = "网关超时";
          break;
        case 505:
          err.message = "HTTP版本不受支持";
          break;
        default:
      }
    }
    message({ message: err.message, type: "error" });
    return Promise.reject(err);
  }
);
let loading;
let loadingCount = 0;

function api(type, url, param, option) {
  if (!option || !option.hideLoading) {
    if (loadingCount === 0) {
      loading = Loading.service({ fullscreen: true });
    }
    loadingCount++;
  }
  let promise;
  switch (type) {
    case "post":
      promise = axios.post(url, param, option);
      break;
    case "get":
      promise = axios.get(url, Object.assign({ params: param }, option));
      break;
    case "delete":
      promise = axios.delete(url, Object.assign({ data: param }, option));
      break;
    case "put":
      promise = axios.put(url, param, option);
      break;
  }
  return promise.then(
    res => {
      if (!option || !option.hideLoading) {
        loadingCount--;
        if (loadingCount === 0) {
          loading && loading.close();
        }
      }
      return res;
    },
    error => {
      if (!option || !option.hideLoading) {
        loadingCount--;
        if (loadingCount === 0) {
          loading && loading.close();
        }
      }
      return Promise.reject(error);
    }
  );
}

export default api;
